// Words every area uses (the vocabulary, R10-S14): Cancel backs out of a dialog, Retry repeats a
// failed load, Undo reverses a done action, Delete is red.
export const common = {
  cancel: "Cancel",
  retry: "Retry",
  undo: "Undo",
  delete: "Delete",
  save: "Save",
  close: "Close",
  done: "Done",
  edit: "Edit",
  back: "Back",
  more: "More",
  moreActions: "More actions",
  copy: "Copy",
  copied: "Copied",
  couldntCopy: "Couldn't copy",
  loading: "Loading…",
  loadingWhat: "Loading {what}…",
  couldntLoad: "Couldn't load {what}.",
  keepEditing: "Keep editing",
  discard: "Discard",
  discardTitle: "Discard your changes?",
  discardBody: "You changed things here that aren't saved yet.",
  offline: "Can't reach Vantage. Check your connection.",
  somethingWrong: "Something went wrong.",
  didntGoThrough: "That didn't go through.",
  you: "You",
  vantage: "Vantage",
};
